export const rolesConstants = {
  UPDATE_ROLE: '[Roles] Update',
  REMOVE_ROLE: '[Roles] Remove',
  LOADING_ROLES: '[Roles] Loading',
  LOADING_ROLES_ERROR: '[Roles] Loading error',
  ROLE_AJAX_CALL: '[Roles] Ajax call',
  ROLE_AJAX_SUCCESS: '[Roles] Ajax success',
  ROLE_AJAX_FAILURE: '[Roles] Ajax error'
}
